// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// ng serve --host  192.168.0.140 --live-reload=false
// ng build --aot --prod

// git remote add origin https://github.com/Baliba/cpledika.git
  // git add.
// git commit - m "initial commit"
// git push - u origin master

// git remote add origin

// "start:host": "ng serve --host 192.168.1.8 --disable-host-check",
// "start:electron": "ng build --base-href ./ && electron .",


// set NODE_OPTIONS=--max_old_space_size=8096

export const environment = {
  production: true
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
